import { Injectable } from '@angular/core';
import { Resolve, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable, of, from } from 'rxjs';
import { take } from 'rxjs/operators';
import { SearchType } from '../classes/enums';
import { PreferencesService } from '../services/preferences.service';
import { AgentService } from '../services/agent.service';

@Injectable()
export class AgentProvinceCityResolver implements Resolve<any> {

  constructor(
    private _preferencesService: PreferencesService,
    private _agentService: AgentService,
  ) { }

  resolve(route: ActivatedRouteSnapshot, rstate: RouterStateSnapshot): Observable<any> {
    const url = rstate.root.firstChild.url;

    let cityName = '';
    const cityRegex =  /(.+)-real-estate-agents/;

    const cityMatches = cityRegex.exec(url[1].path);
    let pageNumber = Number(route.queryParams.page) || 0; // For Pagination
    // We need to remember to decrement this value as pagination arrays start from 0
    if (pageNumber > 0) pageNumber--;

    if (cityMatches && cityMatches.length === 2) {

      cityName = cityMatches[1];
      const province = url[0].path;

      // Make a call to the listings to find the total hits before returning
      return from(
        Promise.all([
          this._preferencesService.agentSearchFiltersChanged.pipe(take(1)).toPromise(),
          this._agentService.getAgentCount(province, cityName)
        ]).then((data) => {
          const filters = data[0];
          const count = data[1];

          // Reformat city name for front end after parsing from URL
          // Capitalize after space, hyphen, slash and replace hyphen with space
          cityName = cityName.replace(/(^\w{1})|([\s-/]{1}\w{1})/g, match => match.toUpperCase());
          cityName = cityName.replace(/-/g, ' ');

          // Update the filters search here in case they've already search before. We need to forcibly update the filters because its saved in the preferences
          filters.text = cityName;
          this._preferencesService.updateSearchFilters(SearchType.AGENT, filters);

          return {city: cityName, province: province, pageNumber: pageNumber, searchType: SearchType.AGENT, numberOfAgents: count};
        }));
    }
    else return of(null);
  }
}
